import {
  EditOutlined,
  StopOutlined,
  ArrowUpOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Tooltip, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TableItem,
  ButtonItem,
  dineroDisabledMask,
  SegmentedItem,
} from "../../../Components/Items";
import AgregarCredito from "./AgregarCredito/AgregarCredito";
import EditarCredito from "./EditarCredito/EditarCredito";
import AumentarCredito from "./AumentarCredito/AumentarCredito";

class Creditos extends Component {
  state = {
    todosCreditos: [],
    modalAgregarCredito: false,
    modalEditarCredito: false,
    modalEditarCreditoId: null,
    modalAumentarCredito: false,
    modalAumentarCreditoCredito: null,
    loading: false,
    valor: 1,
  };

  componentDidMount() {
    this.consultarCreditos(this.state.valor);
  }

  consultarCreditos(valor) {
    this.setState({ loading: true });
    axios
      .post(
        "creditos/selectTodosCreditos",
        { empresaId: this.props.empresaId, valor: valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (!res.data || res.data.status === 404) {
          this.setState({ todosCreditos: [] });
        } else {
          this.setState({
            todosCreditos: res.data.map((value) => ({
              ...value,
              accion: {
                _id: value._id,
                nombre: value.nombre,
                estado: value.estado,
              },
            })),
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false, todosCreditos: [] });
      });
  }

  abrirAgregarCredito() {
    this.setState({ modalAgregarCredito: true });
  }
  cerrarAgregarCredito() {
    this.setState({ modalAgregarCredito: false });
    this.consultarCreditos(this.state.valor);
  }
  abrirEditarCredito(id) {
    this.setState({ modalEditarCredito: true, modalEditarCreditoId: id });
  }
  cerrarEditarCredito() {
    this.setState({ modalEditarCredito: false });
    this.consultarCreditos(this.state.valor);
  }
  abrirAumentarCredito(credito) {
    this.setState({
      modalAumentarCredito: true,
      modalAumentarCreditoCredito: credito,
    });
  }
  cerrarAumentarCredito() {
    this.setState({
      modalAumentarCredito: false,
      modalAumentarCreditoCredito: null,
    });
    this.consultarCreditos(this.state.valor);
  }

  verCredito(id) {
    this.props.history.push("/panel/verCredito", { id });
  }

  cancelarCredito(value) {
    axios
      .post(
        "creditos/cancelarCredito",
        { creditoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Crédito cancelado");
        } else {
          message.error(
            res.data.message || "Sucedió un error y no se pudo cancelar"
          );
        }
        this.consultarCreditos(this.state.valor);
      });
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) return -1;
          if (a.nombre > b.nombre) return 1;
          return 0;
        },
        buscar: "nombre",
        render: (value, record) => (
          <>
            {value}
            {record.contablemente === false && (
              <Tooltip title="Se dio de alta sin generar pólizas: la contabilidad ya estaba registrada">
                <Tag color="default" style={{ marginLeft: 6 }}>
                  Sin contabilidad
                </Tag>
              </Tooltip>
            )}
          </>
        ),
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        responsive: ["md"],
        render: (value) => value?.nombre || "",
      },
      {
        title: "Moneda",
        dataIndex: "moneda",
        key: "moneda",
        responsive: ["md"],
        render: (value) =>
          value ? value.abreviacion + " - " + value.nombre : "",
      },
      {
        title: "Total Crédito",
        dataIndex: "totalCredito",
        key: "totalCredito",
        responsive: ["md"],
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Total Pagado",
        dataIndex: "totalPagado",
        key: "totalPagado",
        responsive: ["md"],
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        render: (value, record) =>
          dineroDisabledMask(
            value !== undefined
              ? value
              : (record.totalCredito || 0) - (record.totalPagado || 0)
          ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "18%",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, record, index) => {
          let buttons = [];

          buttons.push(
            <Tooltip
              key={`ver-tooltip-${index}`}
              title="Ver Crédito"
              placement="top"
              overlayInnerStyle={{
                fontSize: "10px",
                padding: "1px 5px",
                minHeight: "auto",
              }}
            >
              <ButtonItem
                key={`ver-${index}`}
                type="default"
                size="small"
                azul
                icon={<EyeOutlined />}
                onClick={() => this.verCredito(value._id)}
              ></ButtonItem>
            </Tooltip>
          );

          if (this.props.permisoEditarCreditos) {
            buttons.push(
              <Tooltip
                title="Editar Crédito"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarCredito(value._id)}
                ></ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoEditarCreditos && value.estado === 1) {
            buttons.push(
              <Tooltip
                key={`aumentar-tooltip-${index}`}
                title="Aumentar Crédito"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  key={`aumentar-${index}`}
                  type="default"
                  size="small"
                  verde
                  icon={<ArrowUpOutlined />}
                  onClick={() =>
                    this.abrirAumentarCredito({
                      _id: value._id,
                      nombre: value.nombre,
                      totalCredito: record.totalCredito,
                      saldo: record.saldo,
                      abonoProveedor: record.abonoProveedor,
                    })
                  }
                ></ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoCancelarCredito && value.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`cancelar-${index}`}
                title="Seguro que quieres cancelar este crédito (no se podrá reactivar)"
                onConfirm={() => this.cancelarCredito(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip
                  title="Cancelar"
                  placement="top"
                  overlayInnerStyle={{
                    fontSize: "10px",
                    padding: "1px 5px",
                    minHeight: "auto",
                  }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  ></ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Créditos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activo", value: 1 },
                    { label: "Cancelado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    this.consultarCreditos(value);
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              {this.props.permisoAgregarCreditos && (
                <ButtonItem
                  type="primary"
                  olivo
                  key="agregarCredito"
                  onClick={this.abrirAgregarCredito.bind(this)}
                  style={{
                    fontSize: "14px",
                    padding: "6.4px 15px",
                    height: "32px",
                  }}
                >
                  Agregar Crédito
                </ButtonItem>
              )}
            </div>
          }
        />
        <TableItem
          size="small"
          loading={this.state.loading}
          dataSource={this.state.todosCreditos}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (this.props.permisoEditarCreditos) {
                this.abrirEditarCredito(record.accion._id);
              }
            },
          })}
        />
        {this.props.permisoAgregarCreditos && (
          <AgregarCredito
            visible={this.state.modalAgregarCredito}
            cerrarAgregarCredito={this.cerrarAgregarCredito.bind(this)}
          />
        )}
        {this.props.permisoEditarCreditos && (
          <EditarCredito
            id={this.state.modalEditarCreditoId}
            visible={this.state.modalEditarCredito}
            cerrarEditarCredito={this.cerrarEditarCredito.bind(this)}
          />
        )}
        {this.props.permisoEditarCreditos && (
          <AumentarCredito
            credito={this.state.modalAumentarCreditoCredito}
            visible={this.state.modalAumentarCredito}
            cerrarAumentarCredito={this.cerrarAumentarCredito.bind(this)}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarCreditos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207315cd914b37f4b03307"
      )?.activado,
    permisoEditarCreditos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207327cd914b37f4b03308"
      )?.activado,
    permisoCancelarCredito:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207331cd914b37f4b03309"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Creditos);
